import { render, staticRenderFns } from "./ProjectKpiWidget.vue?vue&type=template&id=24f177c6&scoped=true"
import script from "./ProjectKpiWidget.vue?vue&type=script&lang=js"
export * from "./ProjectKpiWidget.vue?vue&type=script&lang=js"
import style0 from "./ProjectKpiWidget.vue?vue&type=style&index=0&id=24f177c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f177c6",
  null
  
)

export default component.exports